var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-dh"},[_c('i',{staticClass:"el-icon-s-home"}),_vm._l((_vm.route),function(e,i){return _c('span',{key:i},[_vm._v(" "+_vm._s(e.name)+" "),(i!==_vm.route.length-1)?_c('span',{staticClass:"ml5 mr5"},[_vm._v(">")]):_vm._e()])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }